interface Proposal {
    isActive: boolean;
    text: string;
    isVisibleByDefault: boolean;
}

// isSorted tells which proposals go first when sorting. By default the active
// ones; the election freezes the selection made when the sort was asked, so
// that the list does not move under the keyboard focus at each selection.
function groupAndSortElectionProposals<T extends Proposal>(
    proposals: Array<T>,
    {
        sortingIsEnabled = false,
        isSorted = (proposal: T) => proposal.isActive,
    }: { sortingIsEnabled?: boolean; isSorted?: (proposal: T) => boolean } = {},
): { visibleProposals: Array<T>; hiddenProposals: Array<T> } {
    const visibleProposals: Array<T> = [];
    const hiddenProposals: Array<T> = [];

    proposals.forEach((proposal) => {
        if (
            proposal.isVisibleByDefault ||
            (sortingIsEnabled && isSorted(proposal))
        ) {
            visibleProposals.push(proposal);
        } else {
            hiddenProposals.push(proposal);
        }
    });

    if (sortingIsEnabled) {
        visibleProposals.sort(function (propA, propB) {
            return Number(isSorted(propB)) - Number(isSorted(propA));
        });
    }

    return {
        visibleProposals,
        hiddenProposals,
    };
}

export default groupAndSortElectionProposals;
